import { render } from "./DistributorTable.vue?vue&type=template&id=642c3bdd&scoped=true"
import script from "./DistributorTable.vue?vue&type=script&lang=ts"
export * from "./DistributorTable.vue?vue&type=script&lang=ts"

import "./DistributorTable.vue?vue&type=style&index=0&id=642c3bdd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-642c3bdd"

export default script